const bodyContainer = document.querySelector(".body-container");
const burgerBtn = document.querySelector(".header__burger-btn");
const burgerMenu = document.querySelector(".header__burger-menu");
const coverBlock = document.querySelector(".burger-overflow");
const modal = document.querySelector(".form-modal");
const contactsButtons = document.querySelectorAll(".header__contact-btn");

if (burgerBtn) {
  const handleBurgerBtnClick = () => {
    burgerBtn.classList.toggle("header__burger-btn--open");
    burgerMenu?.classList.toggle("header__burger-menu--open");
    coverBlock?.classList.toggle("burger-overflow--open");
    bodyContainer.classList.toggle("body-container--no-scroll");
  };

  burgerBtn.addEventListener("click", handleBurgerBtnClick);

  const handleOverflowBlockClick = () => {
    burgerBtn.classList.remove("header__burger-btn--open");
    burgerMenu?.classList.remove("header__burger-menu--open");
    coverBlock?.classList.remove("burger-overflow--open");
    bodyContainer.classList.remove("body-container--no-scroll");
  };

  coverBlock.addEventListener("click", handleOverflowBlockClick);
}

if (contactsButtons) {
  contactsButtons.forEach((btn) =>
    btn.addEventListener("click", () => {
      modal.classList.add("site-modal--opened");
      bodyContainer.classList.add("body-container--no-scroll");
      modal.querySelector("#type").value = "Связаться с нами";
      modal.querySelector("#form_type").value = "Связаться с нами";
      modal.querySelector("#page_link").value = window.location.href;
    })
  );
}
